import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, Observable, of, throwError } from 'rxjs';
import { StorageService } from '../_utils/storage/storage.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private errors: any = null;
  
  constructor(private translocoService: TranslocoService, private router: Router, private storageService: StorageService) {
    this.translocoService.selectTranslateObject('api_errors').subscribe((errors) => {
      this.errors = errors;
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((error: HttpErrorResponse, caught: any) => {
      let errorMessage: string;
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (error.error?.errors?.length > 0)
        errorMessage = error.error.errors.join(', ');
      else
        errorMessage = this.errors['code-' + error.status] || this.errors.general_with_code.replace('%code%', error.status);

      if (error.status && error.status === 401) {
        this.storageService.delete('token');
        this.router.navigate(['/auth/login']);
      }

      // { success: false, error: true, errors: [errorMessage] }
      return of(new HttpResponse({
        body: { success: false, error: true, errors: [errorMessage] },
        headers: error.headers,
        status: error.status,
        statusText: error.statusText,
        url: error.url || "",
      }));
    }));
  }
}